// extracted by mini-css-extract-plugin
export default {"policies":"Policies_policies__3XJWS","title":"Policies_title__Uz8UO","debate":"Policies_debate__C19Om","box":"Policies_box__GaFAe"};